module.exports = __webpack_public_path__ + "img/im the strongest.33f7082a.png";